import React, { FC, PropsWithChildren } from 'react'

import { ErrorPage } from 'ErrorPage'

import { InstrumentedErrorBoundary } from '@library/browser-errors'
import { BROWSER_ERROR_KEYS } from '@library/observability/browser'

import { DeliveryDetails as DeliveryDetailsComponent } from './DeliveryDetails'

export const DeliveryDetailsPage: FC<PropsWithChildren<any>> = (props) => (
  <InstrumentedErrorBoundary
    errorKey={BROWSER_ERROR_KEYS.UNEXPECTED_DELIVERY_DETAILS_PAGE_ERROR}
    fallback={ErrorPage}
  >
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <DeliveryDetailsComponent {...props} />
  </InstrumentedErrorBoundary>
)
